import React, { useState } from 'react';
import {
	TextField,
	Stack,
	Chip,
	FormLabel,
} from '@mui/material';
import { isValidEmail } from '@/utils/constants';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DelegatedEmailsInput = ({
	formik,
	onAddEmail,
	onRemoveEmail,     
	disabled = false,
	minimal = false,
}) => {
	const emails = formik.values.delegatedEmails || [];
	const [inputValue, setInputValue] = useState('');


	const addEmail = () => {
		const email = inputValue.trim().toLowerCase();
		if (!email) return;
		if (!isValidEmail(email)) return; 
		if (emails.includes(email)) return;

		const updatedEmails = [...emails, email];
		formik.setFieldValue('delegatedEmails', updatedEmails);
		onAddEmail(email);
		setInputValue('');
	};

	const removeEmail = (email) => {
		const updatedEmails = emails.filter((e) => e !== email);
		formik.setFieldValue('delegatedEmails', updatedEmails);
		onRemoveEmail(email);
	};

	return (
		<>
			{!minimal && <FormLabel>Delegated Emails</FormLabel>}

			<TextField
				fullWidth
				disabled={disabled}
				placeholder="Type in your delegated addresses here and press enter to save"
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						addEmail();
					}
				}}
			/>

			{emails.length > 0 && (
				<Stack direction="row" spacing={1} flexWrap="wrap" mt={1}>
					{emails.map((email) => (
						<Chip
							key={email}
							label={email}
							onDelete={() => removeEmail(email)}
						/>
					))}
				</Stack>
			)}
		</>
	);
};
